import { FunctionComponent, useMemo } from 'react';
import { getAuthUrl } from 'utils/url-generator';
import {
  CommunityApp,
  CommunityNavigation,
  LoggedInUser,
} from '@atlassian/learning-components';
import useLoggedInUser from 'utils/useLoggedInUser';
import useIsLoggedIn from 'utils/useIsLoggedIn';
import {
  CommunityAnalyticsClient,
  eventType,
} from '@atlassian/community-library';
import {
  accountSwitcherIsActive,
  championsIsActive,
  newNavigationIsActive,
} from 'services/statsig/featureGates';

export const NavBar: FunctionComponent = () => {
  const currentUrl = globalThis?.location?.href ?? window?.location?.href ?? '';

  let updatedUrl;
  // temporary fix: conx-700
  if (currentUrl.includes('/settings')) {
    const url = new URL(currentUrl);
    url.searchParams.delete('errorCode');
    updatedUrl = `${url.origin}${url.pathname}${url.search}`;
  } else {
    updatedUrl = currentUrl;
  }

  const currentPage = encodeURIComponent(updatedUrl);
  const { accountId, name, picture, email } = useLoggedInUser() || {};
  const isLoggedIn = useIsLoggedIn();
  const normalizedUser: LoggedInUser = {
    id: accountId || '',
    publicName: name || '',
    avatar: picture,
  };

  const loginHref = useMemo(
    () =>
      getAuthUrl('login', {
        experience: 'entry-auth',
        email: email || '',
        redirectUrl: currentPage,
      }),
    [currentPage],
  );
  const logoutHref = useMemo(() => {
    // CONX-892: When a user logs out from settings page, redirect them to the home page
    const redirectUrl = decodeURIComponent(currentPage).endsWith(
      '/user/settings',
    )
      ? encodeURIComponent('https://community.atlassian.com')
      : currentPage;
    return getAuthUrl('logout', {
      experience: 'entry-auth',
      email: email || '',
      redirectUrl,
    });
  }, [currentPage]);
  const signupHref = useMemo(
    () =>
      getAuthUrl('signup', {
        experience: 'entry-auth',
        email: email || '',
        redirectUrl: currentPage,
      }),
    [currentPage],
  );
  const switchHref = useMemo(
    () =>
      accountSwitcherIsActive()
        ? getAuthUrl('login', {
            redirectUrl: currentPage,
            experience: 'entry-auth',
            prompt: 'select_account',
          })
        : '',
    [currentPage],
  );

  return (
    <>
      <CommunityNavigation
        currentApp={CommunityApp.PROFILE}
        isLoggedIn={isLoggedIn}
        user={normalizedUser}
        loginHref={loginHref}
        logoutHref={logoutHref}
        signupHref={signupHref}
        switchHref={switchHref}
        showChampions={championsIsActive()}
        showNewMenu={newNavigationIsActive()}
        onAnalyticsSendEvent={(type, payload) =>
          CommunityAnalyticsClient.sendEvent(
            type as unknown as eventType,
            payload,
          )
        }
        email={email || ''}
      />
    </>
  );
};
